import { push } from 'redux-little-router';
import { call, put, takeLatest } from 'redux-saga/effects';

import { routeMap } from 'router';
import { clearUserData, runAs } from '../../services/API';

import { actionTypes, requestFailure, requestSuccess } from './actions';

function* handleRunAs(action) {
  const response = yield call(runAs, action.payload);

  if (response.isOk) {
    const clearResponse = yield call(clearUserData);
    yield put(
      clearResponse.isOk ? requestSuccess(response.data) : requestFailure(clearResponse.error),
    );
    yield put(push(routeMap.home));
  } else {
    yield put(requestFailure(response.error));
  }
}

export default function* userSaga() {
  yield takeLatest(actionTypes.REQUEST_START, handleRunAs);
}
